import type { AtomEffect } from 'recoil'
import { apiClient } from '../api/client'

/**
 * Effect to sync auth token changes with apiClient
 * When token atom changes, update apiClient.setToken()
 */
export const syncTokenEffect: AtomEffect<string | null> = ({ onSet }) => {
  onSet((newToken, _, isReset) => {
    if (isReset) return
    
    apiClient.setToken(newToken)
    console.log('🔑 API token synced:', newToken ? 'Set' : 'Cleared', "token: " + newToken)
  })
}

/**
 * Effect to sync base URL changes with apiClient
 * When apiBaseUrl atom changes, update apiClient.setBaseUrl()
 */
export const syncBaseUrlEffect: AtomEffect<string> = ({ onSet }) => {
  onSet((newUrl, _, isReset) => {
    if (isReset) return

    apiClient.setBaseUrl(newUrl)
    console.log('🌐 API base URL synced:', newUrl)
  })
}
